import { render, staticRenderFns } from "./AliveGamePopup.vue?vue&type=template&id=34af2eb3&scoped=true&"
import script from "./AliveGamePopup.vue?vue&type=script&lang=js&"
export * from "./AliveGamePopup.vue?vue&type=script&lang=js&"
import style0 from "./AliveGamePopup.vue?vue&type=style&index=0&id=34af2eb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34af2eb3",
  null
  
)

export default component.exports